import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-expandable', 'expandRow', 'Izvērst rindu');
Labels.set('ui-table-expandable', 'collapseRow', 'Sakļaut rindu');
Labels.set('ui-table-expandable', 'actions', 'Darbības');
